var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 2000 2000",
    width: "2000pt",
    height: "2000pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 1414.366 1108.091 L 1177.82 1397 L 941.274 1685.909 C 892.429 1745.566 852.774 1731.403 852.774 1654.3 L 852.774 1000 L 852.774 345.7 C 852.774 268.597 892.429 254.434 941.274 314.091 L 1177.82 603 L 1414.366 891.909 C 1463.211 951.566 1463.211 1048.434 1414.366 1108.091 Z ",
    fill: "rgb(255,255,255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.57ffe36d0423ea95bcc1a12563959f6f.svg";
export { ForwardRef as ReactComponent };